import { render } from "./DescriptionCopyLink.vue?vue&type=template&id=2ace0a95&scoped=true"
import script from "./DescriptionCopyLink.vue?vue&type=script&lang=js"
export * from "./DescriptionCopyLink.vue?vue&type=script&lang=js"

import "@/Common/Styles/profileDescription.scss?vue&type=style&index=0&id=2ace0a95&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ace0a95"]])

export default __exports__